import { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';

const useHostelSettings = () => {
  const [settings, setSettings] = useState({
    name: 'DormCircle',
    city: '',
    state: '',
    logo_filename: '',
    contact_info: '',
    address: ''
  });
  const [loading, setLoading] = useState(true);
  const [logoUrl, setLogoUrl] = useState(null);

  const fetchSettings = async () => {
    try {
      const user = JSON.parse(localStorage.getItem('hostelconnect_user') || '{}');
      const hostelId = user.hostel_id;
      const userRole = user.role;
      
      if (!hostelId) {
        console.log('No hostel_id found in user data');
        setLoading(false);
        return;
      }

      if (!userRole) {
        console.log('No role found in user data');
        setLoading(false);
        return;
      }

      // Use role-specific endpoint
      const endpoint = `/v1/${userRole}/settings/${hostelId}`;
      console.log('Fetching settings from:', endpoint);
      
      const response = await apiClient.get(endpoint);
      console.log('Settings response:', response.data);
      setSettings(response.data);
      
      // Set logo URL if logo exists (using public endpoint accessible to all roles)
      if (response.data.logo_url) {
        console.log('Setting logo URL (R2):', response.data.logo_url);
        setLogoUrl(response.data.logo_url);
      } else if (response.data.logo_filename) {
        const logoPath = `${process.env.REACT_APP_BUNNY_CDN}logos/${response.data.logo_filename}`;
        console.log('Setting logo URL (Bunny fallback):', logoPath);
        setLogoUrl(logoPath);
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Error fetching hostel settings:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    
    const loadSettings = async () => {
      if (isMounted) {
        await fetchSettings();
      }
    };
    
    loadSettings();
    
    // Listen for settings updates
    const handleSettingsUpdate = () => {
      if (isMounted) {
        loadSettings();
      }
    };
    
    window.addEventListener('hostel-settings-updated', handleSettingsUpdate);
    
    return () => {
      isMounted = false;
      window.removeEventListener('hostel-settings-updated', handleSettingsUpdate);
    };
  }, []);

  // Helper to get short address (City, State)
  const getShortAddress = () => {
    if (settings.city && settings.state) {
      return `${settings.city}, ${settings.state}`;
    }
    return '';
  };

  return {
    settings,
    loading,
    logoUrl,
    shortAddress: getShortAddress(),
    refreshSettings: fetchSettings
  };
};

export default useHostelSettings;
